import { isoToFormatDate } from "../../functions/formatTime";
import Row from "../common/List/Row";

import { getReceiverText } from "../../functions/message";

const MessageRow = ({ message }) => {
  const cellTexts = [isoToFormatDate(message.createdAt, "yyyy/MM/dd HH:mm")];

  const noteTexts = [getReceiverText(message), message.text];

  return <Row cellTexts={cellTexts} noteTexts={noteTexts} />;
};

export default MessageRow;
